import { Observable, throwError } from "rxjs";
import { Injectable } from "@angular/core";
import { HttpInterceptor, HttpErrorResponse } from "@angular/common/http";
import { HttpRequest } from "@angular/common/http";
import { HttpHandler } from "@angular/common/http";
import { HttpEvent } from "@angular/common/http";
import { catchError, map, retry } from "rxjs/operators";
import { ErrorLoggingService } from "./services/error-logging.service";
import { MatSnackBar } from "@angular/material/snack-bar";

@Injectable()
export class CustomHttpInterceptor implements HttpInterceptor
{

    constructor(
        private logService: ErrorLoggingService,
        private snackBar: MatSnackBar,
    ) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>>
    {

        // prevents infinite loop of trying to log error -> failing to log, throwing new error -> trying to log, -> error etc.
        if (req.url.toLowerCase().includes("logerrorweb") || req.url.toLowerCase().includes("saveerror"))
        {
            return next.handle(req);
        }

        const newReq = req.clone({
            headers: req.headers.set("Content-Type", "application/json"),
            withCredentials: true,
        });

        return next.handle(newReq)
            .pipe(catchError((e) => this.handleError(e, newReq.url)));
    }

    private logError(error: Response | any, httpCallUrl: string = "")
    {
        const newError = JSON.stringify(error);
        const displayError = `Message: ${ error.message } - URL: ${ httpCallUrl }\n${ newError } - Error Code: ${ error.status } -Status Code: ${ error.statusText } `;
        this.logService.logError(displayError);
    }

    private handleError(error: HttpErrorResponse | Response | any, httpCallUrl?: string): Observable<any>
    {

        return new Observable((observer: any) =>
        {
            if (error instanceof HttpErrorResponse)
            {
                if (error.error instanceof Blob)
                {
                    let reader = new FileReader();
                    reader.onload = event =>
                    {
                        observer.error(JSON.parse((<any>event.target).result));
                        observer.complete();
                    };
                    reader.readAsText(error.error);
                } 
                else
                {
                    observer.error(error);
                    observer.complete();
                }
            } 
            else
            {
                observer.error(error);
                observer.complete();
            }
        })
            .pipe(catchError((err) =>
            {
                const errorMessage = this.getErrorMessage(err);
                this.userErrorAlert(err, httpCallUrl);
                this.logError(err, httpCallUrl);
                return throwError(errorMessage);
            }));

    }

    private getErrorMessage(error: Response | any): string
    {
        let errMsg: string;
        if (error instanceof Response)
        {
            const body = error.json() || "";
            const err = JSON.stringify(body);
            errMsg = `${ error.status } - ${ error.statusText || "" } ${ err }`;
        } 
        else if (error instanceof HttpErrorResponse)
        {
            errMsg = error.error.Message || error.message;
        } 
        else if (error.ExceptionMessage)
        {
            errMsg = error.ExceptionMessage;
        } 
        else if (typeof error === 'object')
        {
            errMsg = error.Message
        } 
        else
        {
            errMsg = error.message ? error.message : error.toString();
        }

        return errMsg;
    }

    // any errors we do not have throwing specific dialog will throw snackbars for the errors (less intrusive)
    public userErrorAlert(error: Response | any, httpCallUrl?: string)
    {

        httpCallUrl = httpCallUrl == null ? "" : httpCallUrl.toLowerCase(); // set to something so no undefined errors

        let throwAlert: boolean; // throw snackbar based on which httpcall.

        let errMsg: string = this.getErrorMessage(error);
        error.message = errMsg;

        // listed http calls are handled with their own custom dialogs. only throw snackbar if not handled already.
        throwAlert = !(httpCallUrl.includes("onetimepayment") || httpCallUrl.includes("writemanualdelivery") || httpCallUrl.includes("writeserviceworkorder") ||
            httpCallUrl.includes("writecontractletter") || httpCallUrl.includes("contactweb") || httpCallUrl.includes("addcard") || httpCallUrl.includes("updatepassword")
            || httpCallUrl.includes("addbank") || httpCallUrl.includes("getbankname") || httpCallUrl.includes("aps/removeapsitemv2"));

        if (throwAlert)
        {
            this.snackBar.open(errMsg, "Close", {
                duration: 4000,
            });
        }

    }
}
